import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import ColorSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ColorSetting';
import FontFamily from 'hb-builder/components/common/SettingsLibrary/CommonSettings/FontFamily';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const Style = ({ item, onChange }: ComponentSettingsTab) => {
  const [slider] = item.children || [];
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();

  const settingProps = {
    color,
    networkColors,
    onChange,
  };

  return (
    <ContentWrapper>
      <AccordionTitle isInitiallyOpen title={__('Global Settings')}>
        <ColorSetting
          networkTheming={networkTheming}
          settingKey="containerBackgroundColor"
          title={__('Background color')}
          transparent
          item={item}
          {...settingProps}
        />
      </AccordionTitle>
      <AccordionTitle isInitiallyOpen title={__('Captions')}>
        <FontFamily settingKey="fontFamily" onChange={onChange} item={slider} />
        <ColorSetting
          networkTheming={networkTheming}
          settingKey="textColor"
          title={__('Text color')}
          transparent
          item={slider}
          {...settingProps}
        />
      </AccordionTitle>
    </ContentWrapper>
  );
};

export default Style;

const ContentWrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
